import { RequestedDeliveryModel } from "@GeriMed/Type/ApiModelsExt";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";


export function getRequestedDeliverySettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.requestedDeliverySettings as RequestedDeliveryModel | undefined;
}